import { render, staticRenderFns } from "./reservedMsg.vue?vue&type=template&id=19dca7af&scoped=true&"
import script from "./reservedMsg.vue?vue&type=script&lang=js&"
export * from "./reservedMsg.vue?vue&type=script&lang=js&"
import style0 from "./reservedMsg.vue?vue&type=style&index=0&id=19dca7af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dca7af",
  null
  
)

export default component.exports